import { Button, PageHeader, PageHeaderActions, PageHeaderTitle } from '@customerio/pluma-components/react';

type WizardHeaderProps = {
  title: string;
  exitHref: string;
  canSave: boolean;
  isSaving: boolean;
  onSave: () => void;
};

/** The wizard's title row: the engine being synced, Exit back to the list, and Save for the draft. */
export function WizardHeader({ title, exitHref, canSave, isSaving, onSave }: WizardHeaderProps) {
  return (
    <PageHeader>
      <PageHeaderTitle truncate>{title}</PageHeaderTitle>
      <PageHeaderActions>
        <Button href={exitHref} variant="tertiary" icon="chevron-left" data-test-sql-import-exit>
          Exit
        </Button>
        <Button
          variant="secondary"
          onClick={onSave}
          isLoading={isSaving}
          isDisabled={!canSave}
          data-test-sql-import-save-draft
        >
          Save
        </Button>
      </PageHeaderActions>
    </PageHeader>
  );
}
